
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.9 2C1.3 2 0 3.3 0 5v10c0 1.7 1.3 3 3 3h6c.6 0 1-.4 1-1s-.4-1-1-1H2.9c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v4c0 .6.4 1 1 1s1-.4 1-1V5c0-1.7-1.3-3-3-3h-14zm3 5c-.6 0-1 .4-1 1s.4 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1h-8zm-1 5c0-.6.4-1 1-1h3c.6 0 1 .4 1 1s-.4 1-1 1h-3c-.6 0-1-.4-1-1zm14.8 1.7c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-3.1 3.2-1.5-1.5c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2.2 2.3c.2.2.5.3.7.3s.5-.1.7-.3l3.8-4z","fill":"#282e3e","fill-rule":"evenodd"}})])
          )
        }
      }
    